import { App } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SurveyViewForm from "@/features/survey-views/form";
import { useSurveyViewForm } from "@/features/survey-views/form/hooks/useSurveyViewForm";
import { useCreateSurveyViewMutation } from "@/redux/service";
import { SurveyViewFormValues } from "@/features/survey-views/form/types";
import { SurveyViewColorScheme } from "@/redux/survey-views/types";

const SurveyViewCreate = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { form } = useSurveyViewForm();
  const [createSurveyView] = useCreateSurveyViewMutation();

  const handleSubmit = form.handleSubmit(
    async (values: SurveyViewFormValues) => {
      const data = {
        ...values,
        config: {
          ...values.config,
          colorScheme: values.config.grayScale
            ? SurveyViewColorScheme.GRAY_SCALE
            : SurveyViewColorScheme.DEFAULT,
        },
        answers: values.answers.map((answer) => ({
          answer: answer.answer,
          attachedBlocks: answer.attachedBlocks.map((block) => block.id),
        })),
      };
      const response = await createSurveyView(data).unwrap();
      notification.success({
        message: t("surveyViews.labels.surveyViewCreated"),
      });
      navigate(`/reports/views/${response.id}`);
      form.reset();
    },
  );

  return <SurveyViewForm form={form} handleSubmit={handleSubmit} />;
};

export default SurveyViewCreate;
